import { render, staticRenderFns } from "./MasterSpendingCurveView.vue?vue&type=template&id=51758eb0&"
import script from "./MasterSpendingCurveView.vue?vue&type=script&lang=js&"
export * from "./MasterSpendingCurveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports